import { ThemeProvider } from "@mui/material";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import { theme } from "../../components/constants/muiTheme";
import DetailApprovalPbf from "../../components/screen/ApprovalPbf/DetailApprovalPbf";

const DetailApprovalPbfPage = () => {
  return (
    <PageTemplate
      mainComponent={
        <ThemeProvider theme={theme}>
          <DetailApprovalPbf />
        </ThemeProvider>
      }
      pageRole={3}
      requiredTitle={3} // Apoteker Penanggung Jawab
      bgColor={"gray"}
      header="Detail Approval PBF Purchase"
    />
  );
};

export default HOC(DetailApprovalPbfPage);
